import * as grok from 'datagrok-api/grok';
import { Subject } from 'rxjs';
import { testEvent } from '@datagrok-libraries/utils/src/test';
export function getGridCellColTemp(gridCell) {
    let temp = null;
    let gridCol = null;
    try {
        gridCol = gridCell.dart ? gridCell.gridColumn : null;
        temp = gridCol ? gridCol.temp : null;
    }
    catch {
        [gridCol, temp] = [null, null];
    }
    const tableCol = gridCell.cell.column;
    temp = temp ?? (tableCol ? tableCol.temp : null);
    if (!temp)
        throw new Error(`Grid cell renderer back store (GridColumn or Column) not found.`);
    return [gridCol, tableCol, temp];
}
//@formatter:off
export class CellRendererBackStub {
    onKeyDown(gridCell, e) { }
    onKeyPress(gridCell, e) { }
    onMouseEnter(gridCell, e) { }
    onMouseLeave(gridCell, e) { }
    onMouseDown(gridCell, e) { }
    onMouseUp(gridCell, e) { }
    onMouseMove(gridCell, e) { }
    onClick(gridCell, e) { }
    onDoubleClick(gridCell, e) { }
}
//@formatter:on
export class CellRendererBackBase extends CellRendererBackStub {
    /** Overriding care to trigger {@link onRendered} event. */
    constructor(
    /** Not null if rendered on a grid */
    gridCol, tableCol, logger) {
        super();
        this.gridCol = gridCol;
        this.tableCol = tableCol;
        this.logger = logger;
        this.subs = [];
        this.dirty = true;
        this.destroyed = false;
        this.cleanColVersion = -1;
        this.viewerId = ++CellRendererBackBase.viewerCounter;
        // -- IRenderer --
        this.errors = [];
        this._onRendered = new Subject();
        if (this.tableCol && this.tableCol.dataFrame) {
            this.cleanColVersion = this.tableCol.version;
            this.subs.push(this.tableCol.dataFrame.onDataChanged.subscribe(() => {
                if (this.tableCol?.version !== this.cleanColVersion) {
                    this.cleanColVersion = this.tableCol?.version;
                    this.dirty = true;
                }
            }));
            this.subs.push(this.tableCol.dataFrame.onColumnsRemoved.subscribe((_) => {
                try {
                    // this way we can check if the column is still in the dataframe
                    if (!this.destroyed && this.tableCol && !this.tableCol.dataFrame)
                        this.destroy();
                }
                catch (err) {
                    this.logger.error(err);
                }
            }));
        }
        if (this.tableCol) {
            this.subs.push(grok.events.onTableRemoved.subscribe((eventData) => {
                try {
                    const eventDf = eventData.args.dataFrame;
                    if (this.tableCol?.dataFrame.id === eventDf.id && !this.destroyed)
                        this.destroy();
                }
                catch (err) {
                    this.logger.error(err);
                }
            }));
        }
        if (this.gridCol) {
            this.subs.push(grok.events.onViewRemoving.subscribe((eventData) => {
                try {
                    const eventView = eventData.args.view;
                    if (this.gridCol?.dart &&
                        this.gridCol.grid && this.gridCol?.grid?.dart &&
                        this.gridCol?.grid?.view?.id === eventView.id && !this.destroyed)
                        this.destroy();
                }
                catch (err) {
                    this.logger.error(err);
                }
            }));
        }
    }
    toLog() {
        return `${this.constructor.name}<${this.viewerId}>`;
    }
    destroy() {
        for (const sub of this.subs)
            sub.unsubscribe();
        this.destroyed = true;
    }
    invalidateGrid() {
        if (this.gridCol && this.gridCol.dart)
            this.gridCol.grid?.invalidate();
    }
    reset() {
        this.dirty = false;
    }
    get onRendered() { return this._onRendered; }
    invalidate(caller) {
        this.invalidateGrid();
    }
    async awaitRendered(timeout = 10000, reason = `${timeout} timeout`) {
        const logPrefix = `${this.toLog()}.awaitRendered()`;
        this.logger.debug(`${logPrefix}, start, testEvent before`);
        await testEvent(this._onRendered, () => { }, () => {
            this.invalidate();
        }, timeout, `${logPrefix}, ${reason}`);
        // Rethrow stored syncer error (for test purposes)
        if (this.errors.length > 0) {
            const err = this.errors[0];
            this.errors = [];
            throw err;
        }
        this.logger.debug(`${logPrefix}, end`);
    }
}
CellRendererBackBase.viewerCounter = -1;
//# sourceMappingURL=cell-renderer-back-base.js.map